<template>
    <div v-cloak v-loading="loading" element-loading-text="修改中..." class="page-wrapper">
        <swb-login-head :item="item"></swb-login-head>
        <div class="reg-wrapper retail">
            <div id="regist" class="logreg-banner">
                <div class="logreg-form login-fixed">
                    <h2 class="title">账户重置密码</h2>
                    <div class="msg-hint">
                        <div class="msg-warn hidden"><i class="fa fa-lightbulb-o hint-icon"></i> 公共场所不建议自动登录，以防账号丢失</div>
                    </div>
                    <el-form :model="user" :rules="rules" ref="user" class="demo-ruleForm">
                        <div class="form-row reg mb20">
                            <div class="form-value">
                                <el-form-item prop="phoneNo">
                                    <label class="group-laber"><i class="fa fa-user-o font18"></i></label>
                                    <el-input v-model="user.phoneNo" class="font14" type="text" placeholder="邮箱/用户名/已验证手机" auto-complete="off"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-row reg mb20" :class="{'display-none' : !isOutlandMobileNo }">
                            <div class="form-value">
                                <el-form-item prop="smsEmail">
                                    <label class="group-laber"><i class="fa fa-lock font18"></i></label>
                                    <el-tooltip effect="dark" content="目前 对于海外手机号 需要绑定邮箱用来接收手机短信及验证码" placement="right-start">
                                        <el-input v-model="user.smsEmail" class="font14" type="email" placeholder="绑定邮箱" auto-complete="off"></el-input>
                                    </el-tooltip>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-row reg mb20">
                            <div class="form-value">
                                <label v-if="!btnlock" :class="btnClass" @click="sendSmsForPasswordReset()">获取验证码</label>
                                <label v-else :class="btnClass">( {{nums}} ) 秒后获取</label>
                                <el-form-item prop="smsCode">
                                    <input class="sms font14" type="text" v-model="user.smsCode" placeholder="请输入手机验证码"/>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-row reg mb20">
                            <div class="form-value">
                                <el-form-item prop="password">
                                    <label class="group-laber"><i class="fa fa-lock font18"></i></label>
                                    <el-input v-model="user.password" class="font14" type="password" placeholder="设置密码" auto-complete="off"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-row reg mb20">
                            <div class="form-value">
                                <el-form-item prop="rePassword">
                                    <label class="group-laber"><i class="fa fa-lock font18"></i></label>
                                    <el-input v-model="user.rePassword" class="font14" type="password" placeholder="确认密码" auto-complete="off"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <el-button type="primary" @click="submitForm('user');" class="swb-btn mb20" style="width: 100%;">重置密码</el-button>
                    </el-form>
                </div>
            </div>
        </div>
        <swb-login-foot></swb-login-foot>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import notifyApi from '../../api/notify'
    import userApi from '../../api/user'
    //s
    import SwbLoginHead from './Login-head';

    Vue.regist(SwbLoginHead);

    import SwbLoginFoot from './Login-foot';

    Vue.regist(SwbLoginFoot);

    export default {
        name: 'swb-log-pass-reset',
        desc: '重置密码',
        data: function () {
            var self = this;
            var checkPhoneNo = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    self.isOutlandMobileNo = false;
                    self.user.smsEmail = null;
                    return callback(new Error('手机号不能为空'));
                } else {
                    if(!Utils.isMobileNo(value)) {
                        self.isOutlandMobileNo = false;
                        self.user.smsEmail = null;
                        return callback(new Error('必须是手机号'));
                    } else {
                        if(!Utils.isInlandMobileNo(value)) {
                            self.isOutlandMobileNo = true;
                        }
                        else {
                            self.user.smsEmail = null;
                            self.isOutlandMobileNo = false;
                        }
                        callback();
                    }
                }
            };
            var validateSmsCode = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请输入接收到的验证码'));
                } else {
                    callback();
                }
            };
            var validatePass = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请输入密码'));
                } else {
                    if(!Utils.isNoB(self.user.rePassword)) {
                        self.$refs.user.validateField('rePassword');
                    }
                    callback();
                }
            };
            var validateRePass = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请再次输入密码'));
                } else if(value != self.user.password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };

            function validateEmail(rule, value, callback) {
                let isOutlandMobileNo = self.isOutlandMobileNo;
                if(isOutlandMobileNo) {//海外手机号
                    if(!Utils.isEmail(value)) {
                        callback(new Error('请输入有效的绑定邮箱!'));
                    }
                }
                //
                callback();
            }

            return {
                loading: false,
//                checked: false,
                item: {name: '重置密码', type: 'reset'},
                isOutlandMobileNo: false,//是否海外手机号
                user: {},
                nums: 60,
                clock: '',
                btnlock: false,
                btnClass: 'group-laber sms',
                rules: {
                    phoneNo: [{
                        validator: checkPhoneNo,
                        trigger: 'blur'
                    }],
                    password: [{
                        validator: validatePass,
                        trigger: 'blur'
                    }],
                    rePassword: [{
                        validator: validateRePass,
                        trigger: 'blur'
                    }],
                    smsCode: [{
                        validator: validateSmsCode,
                        trigger: 'blur'
                    }],
                    smsEmail: [{
                        validator: validateEmail,
                        trigger: 'blur'
                    }]
                }
            }
        },

        mounted: function () {
            // this.inputName = this.name || '请输入';
        },
        methods: {
            // 注册发送验证码
            sendSmsForPasswordReset: function () {
                let self = this;
                //
                self.btnClass = 'group-laber sms checked';
                self.btnlock = true;
                self.clock = setInterval(self.doLoop, 1000); //一秒执行一次
                //
                let postData = {};
                postData.phoneNo = self.user.phoneNo;
                if(self.isOutlandMobileNo) {
                    postData.smsEmail = self.user.smsEmail;
                }
                notifyApi.sendSmsForLogPass(postData, function (result) {
                    if(result.type == 'info') {
                        if(result.data != null) {
                            //
                            MsgBox.info(result.data);
                        } else {
                            MsgBox.success(result.message);
                        }
                    } else {
                        //
                        self.clearInterval();
                        MsgBox.warning(result.message);
                    }
                });
            },
            doLoop: function () {
                this.nums--;
                if(this.nums < 0) {
                    this.clearInterval();
                }
            },
            clearInterval: function () {
                clearInterval(this.clock); //清除js定时器
                this.btnlock = false;
                this.nums = 60; //重置时间
                this.btnClass = 'group-laber sms';
            },
            //
            submitForm: function (formName) {
                var self = this;
                this.$refs[formName].validate(function (valid) {
                    if(valid) {
                        self.loading = true;
                        self.submit();
                    } else {
                        return false;
                    }
                });

            },
            submit: function () {
                var self = this;
                //
                var postData = self.user;
                userApi.resetUserLogPass(postData, function (result, jqXhr) {
                    self.loading = false;
                    //
                    if(result.type == "info") {
                        MsgBox.success("重置成功");
                        self.loading = true;
                        window.location.href = getAppUrl(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }

</script>




// WEBPACK FOOTER //
// src/compo/user/LogPassReset.vue